import { SociosSocketEvent, type SocketsListener, useSocketEventListener, withRefreshStrategy } from '@capsicum/common';
import { useMemo } from 'react';

/**
 * A hook to listen to the VTM FTO updated event from the WebSocket.
 * @param updateCallback - The callback to call when the event is received.
 */
export const useFTOupdateFromWS = (updateCallback: () => void) => {
	const listeners = useMemo(
		() =>
			new Map<SociosSocketEvent, SocketsListener>([
				[
					SociosSocketEvent.VTM_FTO_UPDATED,
					withRefreshStrategy({
						listener: () => {
							updateCallback?.();
						}
					})
				]
			]),
		[updateCallback]
	);

	useSocketEventListener(listeners);
};
